import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Horizontal alignment of the Feed's filter toolbar within its container.
// RADIO_BAR left/center/right picker, mirroring SmartFeedSeeMoreAlignment.
export default class FilterToolbarAlignment extends BaseOption {
  static label = "Filter Alignment";
  static userInterfaceComponent = {
    component: inspectorTools.RADIO_BAR,
    iconSize: 24,
    props: {
      options: [
        { icon: "align-left", value: "left" },
        { icon: "align-center", value: "center" },
        { icon: "align-right", value: "right" },
      ],
    },
  };

  static defaultValue = "left";
}
